import React from 'react';

import UpwardLoadingButton from 'ui/Buttons/LoadingButton';
import PropTypes from 'prop-types';

const SubmitButton = (props) => {
   return (
      <UpwardLoadingButton
         type='submit'
         className='btn-dark-orange btn-rounded'
         isLoading={props.isLoading}
         onClick={props.onClick}
         disabled={props.isDisabled}
      >
         { props.label }
      </UpwardLoadingButton>
   );
};

SubmitButton.propTypes = {
   isLoading: PropTypes.bool,
   onClick: PropTypes.func,
   label: PropTypes.string,
   isDisabled: PropTypes.bool,
};

SubmitButton.defaultProps = {
   isLoading: false,
   onClick: null,
   label: 'Submit',
   isDisabled: false,
};

export default SubmitButton;
